function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGold = function SvgGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1463.273,
    height: 990,
    viewBox: "-10 0 1463.273 990"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1060.273 171q-163 0-278.5-25t-115.5-60.5 115.5-60.5 278.5-25 278 25 115 60.5-115 60.5-278 25m-547 513q-52 61-115 103.5t-123.5 60-117.5 10-98-42.5q-54-46-66-125t20-171 101-173q52-61 114.5-103.5t123.5-60 118-10 98 42.5q54 46 66 125t-20 171-101 173m547-419q167 0 287-26 71-16 106-38v158q0 35-115 60t-278 25q-100 0-185-10-22-99-93-160l-56-47q20 6 46 12 120 26 288 26m-338 80q54 46 66 125t-20 171-101 173q-52 62-115 104t-123.5 59.5-118 10q-57.501-7.5-97.5-42.5l-83-70q41 35 98 42.5t118-10 123.5-59.5 114.5-104q69-81 101-173t20-171-66-125zm338 192q167 0 287-26 71-15 106-37v157q0 36-115 61t-278 25q-118 0-216-14 29-70 37-139 2-16 2-35 84 8 177 8m0 273q167 0 287-26 71-15 106-37v157q0 36-115 61t-278 25q-130 0-233-17t-142-43q29-27 53-55 34-41 61-86 113 21 261 21",
    style: {
      fill: "#e1bb3a",
      fillOpacity: 1
    }
  }));
};
export default SvgGold;